import { Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { SyncLoader } from "react-spinners";
import NoDataPrompt from "../NoDataPrompt/NoDataPrompt";
import "./OneTable.css";

const parseDate = (dateString) => {
    if (dateString === 'None' || dateString === 'N/A') {
        return null;
    }

    const parts = dateString.split('-');
    const month = parseInt(parts[0]);
    const day = parseInt(parts[1]);
    const year = parseInt(parts[2]);

    return new Date(year, month - 1, day);
};

export default function OneTable({
    tableHeaders,
    headerSelector,
    tableData,
    ActionBtn,
    ViewBtn,
    PaymentBtn,
    PendingBtn,
    showLoader,
    withActionData,
}) {
    const columns = tableHeaders.map((header, index) => {
        if (header === "-") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: ViewBtn,
                width: "8rem",
                reorder: false,
                wrap: true,
            };
        } else if (header === "INV NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "7.5%",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.id);
                    const valueB = parseFloat(b.id);

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "TOTAL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8vw",
                reorder: true,
                right: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.grand_total.replaceAll(',', ''));
                    const valueB = parseFloat(b.grand_total.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PAID AMNT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8vw",
                reorder: true,
                right: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.paid_amount.replaceAll(',', ''));
                    const valueB = parseFloat(b.paid_amount.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "RFND PMT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8vw",
                reorder: true,
                right: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.balance.replaceAll(',', ''));
                    const valueB = parseFloat(b.balance.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "BALANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.balance.replaceAll(',', ''));
                    const valueB = parseFloat(b.balance.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "SALES DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.sales_date);
                    const valueB = parseDate(b.sales_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === ".") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: ViewBtn,
                width: "7%",
                reorder: false,
                wrap: true,
            };
        } else if (header === "*") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: PaymentBtn,
                width: "7%",
                reorder: false,
                wrap: true,
            };
        } else if (header === "ACTIONS" && !withActionData) {
            return {
                name: header,
                button: true,
                cell: ActionBtn,
                width: "8rem",
                reorder: true,
            };
        } else if (header === " ") {
            return {
                name: header,
                button: true,
                cell: PendingBtn,
                // width: "10vw",
                reorder: true,
            };
        } else if (header === "STATUS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "5%",
            };
        } else if (header === "PARTICULARS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            }; 
        } else if (header === "REQ BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            }; 
        } else if (header === "CASH IN") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header === "CASH OUT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header === "ADDED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header === "ADDED ON") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("INV NO.")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                // right: true,
                sortable: true,
                width: "7.5%",
                wrap: true,
                reorder: true,
            };
        } else if (header === "DOC. NO") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                sortable: true,
                width: "8%",
                wrap: true,
                reorder: true,
            };
        } 
        // else if (header.includes("FRANCHISEE")) {
        //     return {
        //         name: header,
        //         selector: (row) => row[headerSelector[index]],
        //         sortable: true,
        //         width: "20%",
        //         wrap: true,
        //         reorder: true,
        //     };
        // } else if (header.includes("FRANCHISEE FEE")) {
        //     return {
        //         name: header,
        //         selector: (row) => row[headerSelector[index]],
        //         sortable: true,
        //         width: "5%",
        //         reorder: true,
        //     };
        // } 
        else if (
            header === "TOTAL" ||
            header === "BALANCE" ||
            header === "PAID AMOUNT" ||
            header === "RFND PMT" ||
            header === "PAID AMNT"
        ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                width: "8rem",
                wrap: true,
                reorder: true,
                sortable: true,

            };
        }
        else if (
            header.includes("DATE") ||
            header.includes("TOTAL") ||
            header.includes("BALANCE")
        ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                width: "8rem",
                wrap: true,
                sortable: true,
                reorder: true,
            };
        }       
            else if (
                header.includes("CASH")||
                header.includes("BALANCE")
            ) {
                return {
                    name: header,
                    selector: (row) => row[headerSelector[index]],
                    right: true,
                    width: "8rem",
                    wrap: true,
                    sortable: true,
                    reorder: true,
                };
        } else {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                wrap: true,
                reorder: true,
            };
        }
    });

    const footer = {
        title: 'TOTAL',
        name: 'TOTAL',
        selector: 'TOTAL',
        width: "15%",

      };

    // const footer = tableHeaders.map((header, index) => {
    //     if (
    //         header === "TOTAL" ||
    //         header === "BALANCE" || header === "PAID AMOUNT"
    //     ) {
    //         return {
    //             name: header,
    //             selector: (row) => row[headerSelector[index]],
    //             width: "9%",
    //             cell: "JENO LEE",
    //             wrap: true,
    //         };
    //     } else {
    //         return {
    //             name: header,
    //             selector: (row) => row[headerSelector[index]],
    //             cell: "JENO LEE",
    //             width: "8rem",
    //             wrap: true,
    //         };
    //     }
    // });

    const paginationComponentOptions = {
        rowsPerPageText: "",
        noRowsPerPage: true,
    };

    // const customStyles = {
    //     rows: {
    //         style: {
    //             minHeight: "5.2vh",
    //         },
    //     },
    // };

    const customStyles = {
        rows: {
            style: {
                minHeight: "5.2vh",
                flexWrap: "wrap",
                fontSize: "12px",
                whiteSpace: "pre",
            },
        },
        headCells: {
            style: {
                flexWrap: "wrap",
                fontSize: "12px",
                width: "100%",
                wordWrap: "breakWord",
            },
        },
    };

    return showLoader ? (
        <div className="d-flex justify-content-center my-5">
            <SyncLoader color="var(--primary-color)" size={15} />
        </div>
    ) : (
        <DataTable
            grow
            pagination
            responsive
            striped
            fixedHeader
            fixedHeaderScrollHeight="50vh"
            columns={columns}
            footer={footer}
            data={tableData}
            customStyles={customStyles}
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent={<NoDataPrompt />}
        />
    );
}
